export const toggleSlideOut =
    (
        activeIndex: number,
        setActiveIndex: (activeIndex: number) => void,
        openSlide: boolean,
        setOpenSlide: (openSlide: boolean) => void
    ) =>
    (): void => {
        setOpenSlide(openSlide)
        setActiveIndex(activeIndex)
    }

export const prevClickHandler = (activeIndex: number, setActiveIndex: (activeIndex: number) => void) => (): void => {
    setActiveIndex(--activeIndex)
}

export const nextClickHandler = (activeIndex: number, setActiveIndex: (activeIndex: number) => void) => (): void => {
    setActiveIndex(++activeIndex)
}
